<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('placeOrder.BatchExport')"
    :visible.sync="dialogVisibleExport"
    top="10vh"
    width="600px"
    @close="clearForm"
  >
    <el-form
      ref="exportRuleForm"
      :model="exportRuleForm"
      class="demo-exportRuleForm"
      label-position="top"
    >
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="NumberType"
      >
        <el-select v-model="exportRuleForm.NumberType" style="width: 80%">
          <template v-if="activeName === '0'">
            <el-option key="1" :label="$t('collectionCenter.Barcode')" :value="3" /><!--条形码-->
            <el-option
              key="2"
              :label="$t('collectionCenter.lanshouOrderNum')"
              :value="4"
            /><!--揽收订单号-->
            <el-option
              key="3"
              :label="$t('collectionCenter.customerOrderNum')"
              :value="5"
            /><!--客户订单号-->
          </template>
          <template v-else>
            <el-option
              key="2"
              :label="$t('collectionCenter.waybillNumber')"
              :value="1"
            /><!--运单号-->
            <el-option key="3" :label="$t('GlobalSetObj.ScanNumber')" :value="2" /><!--扫描单号-->
          </template>
        </el-select>
      </el-form-item>
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur']
        }"
        prop="inputValue"
        style="width: 100%"
      >
        <el-input
          v-model="exportRuleForm.inputValue"
          :placeholder="$t('orderCenterCont.Multiple')"
          clearable
          rows="6"
          type="textarea"
        />
      </el-form-item>
      <el-form-item
        :rules="{
          required: true,
          message: $t('GlobalSetObj.pleaseChoose'),
          trigger: ['blur']
        }"
        prop="withImage"
        style="width: 100%"
      >
        <el-radio-group v-model="exportRuleForm.withImage">
          <el-radio :label="true">{{ $t('trailer.withImages') }}</el-radio>
          <el-radio :label="false">{{ $t('trailer.withoutImages') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin: 15px 0">
      <el-button
        size="small" @click="dialogVisibleExport = false"
      >{{ $t('GlobalSetObj.Cancelar') }}
      </el-button>
      <el-button
        size="small" type="primary" @click="comfire"
      >{{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { goRWExportList } from '@/utils/goExportList';
import { collectProblemBatchNumberExport } from '@/api/newExpressAPI';

export default {
  name: 'OrderNumberExport',
  data() {
    return {
      dialogVisibleExport: false,
      exportRuleForm: {
        NumberType: 3,
        inputValue: '',
        withImage: null // 是否带图片导出，true=带图片，false=不带图片
      },
      activeName: '0'
    };
  },
  methods: {
    handleOpen(val) {
      this.activeName = val;
      if (this.activeName === '0') {
        this.exportRuleForm.NumberType = 3;
      } else {
        this.exportRuleForm.NumberType = 1;
      }
      this.dialogVisibleExport = true;
    },
    clearForm() {
      this.exportRuleForm.inputValue = '';
      this.exportRuleForm.withImage = null;
      this.$nextTick(() => {
        this.$refs['exportRuleForm'].clearValidate();
      });
    },
    comfire() {
      this.$refs['exportRuleForm'].validate((valid) => {
        if (valid) {
          const numberList = this.exportRuleForm.inputValue
            ? this.exportRuleForm.inputValue.split('\n')
            : [];
          const numList = numberList.filter((item) => item !== '');
          if (numList.length > 100000) {
            this.$message.error(this.$t('GlobalSetObj.notMore10w'));
            return;
          }
          const param = {
            numberType: this.exportRuleForm.NumberType,
            numberList: numList,
            withImage: this.exportRuleForm.withImage
          };
          // 导出列表信息
          collectProblemBatchNumberExport(param).then((res) => {
            if (res.code === 200) {
              this.dialogVisibleExport = false;
              goRWExportList(this);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
